// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filters-section {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.filters {
    display: flex;
    align-items: center;
    gap: 10px;
}

.filters .form-control {
    min-width: 150px;
    max-width: 200px;
    height: 38px;
    font-size: 14px;
}

.filters .btn {
    height: 38px;
    padding: 6px 20px;
    font-size: 14px;
    font-weight: 500;
    white-space: nowrap;
}

/* Mobile responsiveness for filters */
@media (max-width: 768px) {
    .filters {
        flex-direction: column;
        gap: 10px;
        width: 100%;
    }

    .filters .form-control,
    .filters .btn {
        width: 100%;
    }

    .dashboard-header .row {
        flex-direction: column;
        gap: 15px;
    }

    .dealership-link {
        text-align: center;
        display: block;
    }
}

/* Ensure proper spacing and alignment */
.mx-1 {
    margin-left: 0.25rem !important;
    margin-right: 0.25rem !important;
}

.ml-2 {
    margin-left: 0.5rem !important;
}
`, "",{"version":3,"sources":["webpack://./src/Shared/LocationFilters.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,sCAAsC;AACtC;IACI;QACI,sBAAsB;QACtB,SAAS;QACT,WAAW;IACf;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,kBAAkB;QAClB,cAAc;IAClB;AACJ;;AAEA,wCAAwC;AACxC;IACI,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;AAClC","sourcesContent":[".filters-section {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-end;\r\n}\r\n\r\n.filters {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n}\r\n\r\n.filters .form-control {\r\n    min-width: 150px;\r\n    max-width: 200px;\r\n    height: 38px;\r\n    font-size: 14px;\r\n}\r\n\r\n.filters .btn {\r\n    height: 38px;\r\n    padding: 6px 20px;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    white-space: nowrap;\r\n}\r\n\r\n/* Mobile responsiveness for filters */\r\n@media (max-width: 768px) {\r\n    .filters {\r\n        flex-direction: column;\r\n        gap: 10px;\r\n        width: 100%;\r\n    }\r\n\r\n    .filters .form-control,\r\n    .filters .btn {\r\n        width: 100%;\r\n    }\r\n\r\n    .dashboard-header .row {\r\n        flex-direction: column;\r\n        gap: 15px;\r\n    }\r\n\r\n    .dealership-link {\r\n        text-align: center;\r\n        display: block;\r\n    }\r\n}\r\n\r\n/* Ensure proper spacing and alignment */\r\n.mx-1 {\r\n    margin-left: 0.25rem !important;\r\n    margin-right: 0.25rem !important;\r\n}\r\n\r\n.ml-2 {\r\n    margin-left: 0.5rem !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
